/* eslint-disable @typescript-eslint/no-explicit-any */
import Link, { LinkProps } from 'next/link'
import { useRouter } from 'next/router'
import { PropsWithChildren } from 'react'

import { useAmplitude } from '@/contexts/AmplitudeProvider'
// components/RetainQueryLink.tsx
import { getDeviceId } from '@/services/amplitude/getDeviceId'
import { getAllExperimentsAndVariants } from '@/utils/getAllExperimentsAndVariants'
import { getGaClientId } from '@/utils/getGaClientId'
import { getGASessionId } from '@/utils/getGASessionId'

interface RetainQueryLinkProps extends LinkProps {
  ctaReference?: string
}

const RetainQueryLink = ({
  href,
  ctaReference,
  ...props
}: RetainQueryLinkProps & PropsWithChildren<any>) => {
  // 1. use useRouter hook to get access to the current query params
  const router = useRouter()
  const { analytics } = useAmplitude()

  // 2. get the pathname
  const pathname = typeof href === 'object' ? href.pathname : href

  // 3. get the query from props
  const query =
    typeof href === 'object' && typeof href.query === 'object' ? href.query : {}

  // 4. get the hash from props
  const hash = typeof href === 'object' ? href.hash : ''

  return (
    <Link
      {...props}
      href={{
        hash,
        pathname: pathname,
        // combine router.query and query props
        query: {
          ...router.query,
          ...query
        }
      }}
      onClick={(e: {
        nativeEvent: unknown
        currentTarget: { href: string }
      }) => {
        const textSection = (e.nativeEvent as unknown as { section: string })
          .section

        const textButton = (e.nativeEvent as unknown as { clicktext: string })
          .clicktext

        analytics?.track({
          event_type: 'cta ton',
          event_properties: {
            name: 'cta ton',
            section_reference: textSection,
            cross_lead_id: getGASessionId(),
            client_id_ga: getGaClientId(),
            user_agent: window?.navigator?.userAgent,
            category: `${e.currentTarget.href}`,
            cta_reference: ctaReference ? ctaReference : textButton,
            source: router.pathname,
            experiments: JSON.stringify(getAllExperimentsAndVariants())
          },
          device_id: getDeviceId(),
          user_agent: window?.navigator?.userAgent
        })
      }}
    />
  )
}
export default RetainQueryLink
